import type { AgeBand } from '../types';
import { AGE_BANDS } from '../constants';

const MONTHS_PER_YEAR: number = 12;

function completedMonths(birthDate: string, on: Date): number | null {
  const dob: Date = new Date(birthDate);
  if (isNaN(dob.getTime())) return null;
  let months: number = (on.getFullYear() - dob.getFullYear()) * MONTHS_PER_YEAR + (on.getMonth() - dob.getMonth());
  if (on.getDate() < dob.getDate()) months -= 1;
  return months;
}

// The age band a child falls into on a given day (defaults to today), derived
// from how many whole months old the child is. Returns null for an unparseable
// birth date or a date before the child was born.
export function ageBandForBirthDate(birthDate: string, on: Date = new Date()): AgeBand | null {
  const months: number | null = completedMonths(birthDate, on);
  if (months === null || months < 0) return null;
  return (
    AGE_BANDS.find(
      (band: AgeBand): boolean => months >= band.minMonths && (band.maxMonths === null || months <= band.maxMonths),
    ) ?? null
  );
}
